<template>
  <div class="input-item">
    <label class="checkbox" for="inGuild">
      <input type="checkbox" class="checkbox__native" id="inGuild"
             v-model="inGuild"> Jsme členem Cechu suché výstavby ČR
      <span class="checkbox__control"></span>
    </label>
    <div v-if="guildMemberNotInDatabase && identificationNumber" class="error-field error-field--checkbox">
      <span>V databázi členů Cechu suché výstavby ČR jsme vás nenalezli. <br>Pokud jste si však svým členstvím jisti, uveďte tuto skutečnost do poznámky.</span>
    </div>
  </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';
    import {guildMemberVerify} from '../api/guild';

    export default {
        name: 'SsvOrderInGuild',
        computed: {
            ...mapFields('ssvOrder', [
                'parameters.inGuild',
                'parameters.inGuildOriginal',
                'billingInformation.identificationNumber',
            ]),
        },
        data: function () {
            return {
                guildMemberNotInDatabase: false,
            }
        },
        watch: {
            inGuild: function (newValue) {
                if (newValue === true) {
                    this.inGuildOriginal = true;
                    this.verifyGuildMember();
                }
            }
        },
        methods: {
            verifyGuildMember() {
                if (this.identificationNumber) {
                    guildMemberVerify({identificationNumber: this.identificationNumber})
                        .catch(() => {
                            this.inGuild = false;
                            this.guildMemberNotInDatabase = true;
                        });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/parameters/OrderInGuild.vue